import { cashbackApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useCashbackTotalQuery = () => {
  return useQuery([QUERIES.CASHBACK_TOTAL], () => cashbackApi.getTotal());
};
